export class DomainIdentity {
  domain: string
  cnameTokens: Array<string>
  dkimStatus: 'SUCCESS' | 'PENDING' | 'FAILED'
  mailFromStatus: 'SUCCESS' | 'PENDING' | 'FAILED'
  domainVerificationStatus: 'SUCCESS' | 'PENDING' | 'FAILED'
  everythingOk: boolean

  constructor(option?: DomainIdentity) {
    this.domain = option?.domain ?? ''
    this.cnameTokens = option?.cnameTokens ?? new Array()
    this.dkimStatus = option?.dkimStatus ?? 'PENDING'
    this.mailFromStatus = option?.mailFromStatus ?? 'PENDING'
    this.domainVerificationStatus = option?.domainVerificationStatus ?? 'PENDING'
    this.everythingOk = option?.everythingOk ?? false
  }
}
